import {Node, NodeSpec} from 'prosemirror-model'

// from prosemirror-tables

export const table: NodeSpec = {
  group: 'block',
  attrs: {
    state: {default: 'default'}, /* 'maximized' | 'default' */
  },
  isolating: true,
  content: 'tableRow+',
  tableRole: 'table',
  parseDOM: [{ tag: 'table' }],
  toDOM: (node: Node) => {
    const classes = ['table-wrap'];
    if (node.attrs.state === 'maximized') {
      classes.push('table-wrap--maximized')
    }
    return ['div', { class: classes.join(' ') }, ['table', ['tbody', 0]]]
  },
}

export const tableRow: NodeSpec = {
  content: 'tableCell+',
  tableRole: 'row',
  isolating: true,
  parseDOM: [{ tag: 'tr' }],
  toDOM: () => ['tr', 0],
}

export const tableDataCell: NodeSpec = {
  attrs: {
    colspan: { default: 1 },
    rowspan: { default: 1 },
    colwidth: { default: null },
  },
  group: 'tableCell',
  isolating: true,
  content: 'block+',
  tableRole: 'cell',
  parseDOM: [
    { tag: 'td' },
    { tag: 'th' }, // Support parsing <th> tags as table cells
  ],
  toDOM: () => ['td', 0],
}

export const isTableCell = (node: Node) => node.type.spec === tableDataCell;
export const isTable = (node: Node) => node.type.spec === table;
